<template>
  <el-group-title title="物资清单" class="contractMaterialsChecklist">
    <template slot="groupTitle">
      <el-form
        :model="formcontractMaterialsChecklist"
        label-width="100px"
        class="ccui-form ccui-form-detail"
        style="overflow: visible"
      >
        <el-table
          :data="dataInfo"
          style="margin-bottom: 20px; width: 100%"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="materialsCode"
            label="物资编码"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="materialsName"
            label="物资名称"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="specifications"
            label="规格型号"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="measuringUnit"
            label="计量单位"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="num"
            label="数量"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="priceExcludeTax"
            label="不含税金额（元）"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceExcludingTax"
            label="不含税单价（元）"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceIncludingTax"
            label="含税单价（元）"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="priceIncludeTax"
            label="含税金额"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="tax"
            label="含税税额"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="desc"
            label="物料描述"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="outstandingQuantity"
            label="未结算数量"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="changeNum"
            label="变更数量"
            align="left"
          >
          </el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "contractMaterialsChecklist",
  props: {
    dataInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          id: "",
          contractMaterialsId: "",
          materialsCode: "",
          materialsName: "",
          specifications: "",
          measuringUnit: "",
          num: "",
          priceExcludeTax: "",
          unitPriceExcludingTax: "",
          unitPriceIncludingTax: "",
          priceIncludeTax: "",
          tax: "",
          desc: "",
          remark: "",
          outstandingQuantity: "",
          changeNum: ""
        }
      ],
      formcontractMaterialsChecklist: {}
    };
  },
  watch: {
    dataInfo() {
      this.tableData = this.dataInfo;
    }
  }
};
</script>
